<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter">
            <el-form-item label="流量池名称：">
                <el-input v-model.trim="searchForm.name" @keyup.enter.native="getListHandler" placeholder="请输入轮询名称"
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="用户名称：">
                <el-select v-model="searchForm.userId" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
                        :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getListPageHandle">搜索</el-button>
                <el-button type="success" plain @click="addTask()">添加流量池</el-button>

                <el-button type="success" plain @click="excelPool()">导出流量池</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" style="width:100%;margin-top: 20px;" border fit highlight-current-row
            :header-cell-style="{ background: '#f5f5f5' }" :default-sort="{ prop: 'rpTime', order: 'descending' }">
            <!-- <el-table-column type="index" label="序号" width="30" align="center"></el-table-column> -->
            <el-table-column prop="name" label="流量池名称" width="150" align="center"></el-table-column>
            <el-table-column prop="userName" label="所属用户" align="center"></el-table-column>
            <el-table-column prop="price" label="单价/元" align="center"></el-table-column>
            <el-table-column prop="totalSim" label="卡板总数" align="center"></el-table-column>
            <el-table-column prop="activeSim" label="本月激活" align="center"></el-table-column>
            <el-table-column prop="upMonthUse" label="上月用量/G" align="center"></el-table-column>
            <el-table-column prop="upMonthPrice" label="上月消耗/元" align="center"></el-table-column>
            <el-table-column prop="monthUse" label="本月用量/G" align="center"></el-table-column>
            <el-table-column prop="monthPrice" label="本月消耗/元" align="center"></el-table-column>
            <el-table-column prop="dayUse" label="日均消耗/G" align="center"></el-table-column>
            <el-table-column prop="userAmount" label="剩余预存/元" align="center"></el-table-column>
            <el-table-column prop="userAmountLog" label="预存总额/元" align="center"></el-table-column>
            <el-table-column prop="stateName" label="状态" align="center"></el-table-column>
            <el-table-column align="center" label="备注">
                <template v-slot="scope">
                    <el-tooltip :content="scope.row.remark">
                        <p style="color:crimson"> {{ scope.row.remark }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>

            <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
            <el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>

            <el-table-column label="操作" align="center" width="180" fixed="right">
                <template slot-scope="scope">
                    <el-button @click="updateTask(scope.row)" type="text" size="small">修改</el-button>
                    <el-button @click="excelTask(scope.row.id)" type="text" size="small">管理卡号</el-button>
                    <el-button @click="excelLoad(scope.row.id)" type="text" size="small">导出账单</el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true" title="失败记录" :visible.sync="failVisible" width="1000px"
            :close-on-click-modal="false" @close="cancel">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号"></el-table-column>
                <el-table-column prop="remark" label="失败原因"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage" :page-sizes="[10, 50, 100, 500]" :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>







        <el-dialog :append-to-body="true" title="流量池管理" :visible.sync="taskFlg" width="600px" class="notifyDetail"
            :close-on-click-modal="false" @close="taskFlg = false">
            <el-form ref="taskData" :model="taskData" label-width="140px">

                <el-form-item label="流量池名称：" prop="name">
                    <el-input v-model="taskData.name"></el-input>
                </el-form-item>
                <el-form-item label="单价/元：" prop="price">
                    <el-input v-model="taskData.price"></el-input>
                </el-form-item>
                <el-form-item label="所属用户：" prop="userId">
                    <el-select v-model="taskData.userId" filterable>
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="类型：" prop="state">
                    <el-radio-group v-model="taskData.state">
                        <el-radio :label="1">禁用</el-radio>
                        <el-radio :label="0">启用</el-radio>
                    </el-radio-group>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="taskFlg = false">取 消</el-button>
                <el-button type="primary" @click="sureTask()">确 定</el-button>
            </div>
        </el-dialog>





        <el-dialog :append-to-body="true" title="管理卡号" :visible.sync="excelFlg" width="600px" @close="excelFlg = false"
            :close-on-click-modal="false">
            <el-form ref="excelData" :model="excelData" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('lunxun/excel/update/pool')" :headers="setHeader()"
                        :auto-upload="false" :data="excelData" :on-change="handleChange" :on-success='handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="类型：" prop="excelData">
                    <el-radio-group v-model="excelData.type">
                        <el-radio label="1">删除卡号</el-radio>
                        <el-radio label="0">添加卡号</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="excelFlg = false">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler">确 定</el-button>
            </div>
        </el-dialog>





        <el-dialog :append-to-body="true" title="导出对账单" :visible.sync="loadFlg" width="600px" class="notifyDetail"
            :close-on-click-modal="false" @close="loadFlg = false">
            <el-form ref="loadData" :model="loadData" label-width="140px">

                <el-form-item label="核算周期：">
                    <el-date-picker v-model="loadData.month" type="month" placeholder="选择结算月份"
                        value-format="yyyy-MM"></el-date-picker>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="loadFlg = false">取 消</el-button>
                <el-button type="primary" @click="toLoadExcel()">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
import common from '@/utils/common.js'
import { getBgdRechargeList, getBgdRechargeFailLists, getPkgListOfGroup } from '@/api/sim.js'
export default {
    data() {
        return {
            textRemark: '无次月停机',
            editVisibale: false,
            editForm: {
                type: "",
                supplierNames: '',
                supplierCodes: [],
            },
            branchSupplierOption: [],



            searchForm: {
                lunState: '',
                name: '',
                time: ''
            },

            //订单列表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            failVisible: false,
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            batchOptVisible: false,
            batchOptForm: {
                name: '',
                sleepTime: '',
                threadSize: ''
            },

            taskFlg: false,
            taskData: {
                id: '',
                name: '',
                state: '',
                userId: '',
                price: ''
            },
            addTaskFlg: false,

            excelData: {
                id: '',
                type: ''
            },
            excelFlg: false,

            loadData: {
                id: '',
                month: '',
            },
            loadFlg: false,
        }
    },
    created() {
        this.getListPageHandle();
        common.sysRequest('lunxun/select/pool/user/list', {}, 'post').then(res => {
            if (res.data.code == 200) {
                this.branchSupplierOption = res.data.data;
            } else {
                this.$message.error(res.data.message);
            }
        })
    },
    methods: {
        excelPool() {
            common.sysRequest('export/allPool', this.searchForm, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success('数据导出中,请稍候去下载专区下载');
                    this.loadFlg = false;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        toLoadExcel() {
            common.sysRequest('export/monthUse', this.loadData, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success('数据导出中,请稍候去下载专区下载');
                    this.loadFlg = false;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        excelLoad(id) {
            this.loadData.id = id;
            this.loadData.month = '';
            this.loadFlg = true;
        },
        excelTask(id) {
            this.excelData.id = id;
            this.excelFlg = true;
        },


        addTask() {
            this.addTaskFlg = true;
            this.taskData.id = '';
            this.taskData.name = '';
            this.taskData.userId = '';
            this.taskData.state = '1';
            this.taskData.price = '';
            this.taskFlg = true;
        },
        updateTask(row) {
            this.addTaskFlg = false;
            this.taskData.id = row.id;
            this.taskData.name = row.name;
            this.taskData.state = row.state;
            this.taskData.userId = row.userId;
            this.taskData.price = row.price;
            this.taskFlg = true;
        },
        sureTask() {
            let path = "lunxun/update/task";
            if (this.addTaskFlg == true) {
                path = "lunxun/add/task";
            }
            common.sysRequest(path, this.taskData, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.getListPageHandle();
                    this.taskFlg = false;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },

        sureBatchChgStateHandler() {
            this.$refs.excelData.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });
        },

        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }

        },

        handleSuccess(res) {
            if (res.code == 200) {
                this.getListPageHandle();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
            this.excelFlg = false;
            this.$refs.upload.clearFiles();
        },

        showBatchChgStateHandler() {
            this.batchOptVisible = true;
        },



        confirmHandler() {
            var d = {
                ...this.editForm
            }
            d.supplierCodes = d.supplierCodes.join("，");
            let path = "lunxun/manage/state";
            common.sysRequest(path, d, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.cancel();
                    this.getListPageHandle();

                } else {
                    this.$message.error(res.data.message);
                }
            })

        },
        showSimManage(type) {
            if (type == 2) {
                this.textRemark = '有可用套餐复机'
            } else {
                this.textRemark = '无次月停机';
            }
            this.editForm.type = type;
            this.editVisibale = true;
        },

        chooseAll() {

        },
        cancelChooseAll() {
        },



        showEditDialog(id) {
            this.$confirm("因系统会不间断轮询卡，执行失败卡轮询会占用大量服务器资源，失败数据过多可能会影响服务器稳定。 确定还要执行失败卡轮询吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    id: id
                }
                common.sysRequest('lunxun/reload/fail/sim', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.getListPageHandle();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }

                })
            })



        },
        cancel() {
            this.batchOptVisible = false;
            this.$refs.batchOptForm.resetFields();
            this.editForm = {
                type: "",
                supplierCodes: [],
            }
            this.editVisibale = false;
            this.failVisible = false;
        },
        goToDetailPage(row) {
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListPageHandle($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('lunxun/select/all/task/page', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val) {
            if (this.failVisible) {
                this.tbpg_fail.currentPage = val
                this.goToInfoFailPage(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val
                this.getListPageHandle();
            }
        },
        //失败列表
        goToInfoFailPage(id, $event) {
            this.failVisible = true;
            this.currentId_fail = id;
            var data = {
                'id': id
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', data);
            common.sysRequest('lunxun/select/all/task/info/fail', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg_fail');

            })

        },
        handleCurrentChange(val) {
            if (this.failVisible) {
                this.tbpg_fail.currentPage = val
                this.goToInfoFailPage(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val
                this.getListPageHandle();
            }
        },
        //执行sim卡轮训
        lunXunSimTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '如果有轮训尚未结束，请勿重复执行轮训！确定要手动执行SIM卡轮训吗？')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/sim', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.getListPageHandle();
                                this.$message.success(res.data.message);
                                done();
                            } else {
                                this.$message.error(res.data.message);
                                done();
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })


        },
        //执行代理商统计
        lunXunAgentTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '确认要手动执行代理商统计吗？')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/agentCount', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.getListPageHandle();
                                done();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })

        },
        lunXunPauseTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '确认要手动执行没有次月套餐停机吗？此操作请谨慎操作！')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/pause/sim', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.getListPageHandle();
                                done();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })

        },
        lunXunActiveTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '确认要手动执行有有效套餐复机吗？')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/active/sim', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.getListPageHandle();
                                done();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })

        },
        //重新购买
        buyPkgReload(rowData) {
            let data = {
                id: rowData.id,
                iccid: rowData.iccid,
                otherOrderNo: rowData.downOrder,
                isNextMonth: rowData.isNextMonth,
                packgeId: rowData.downPackageId
            }
            common.sysRequest('external/buy/pkg/reload', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.getListPageHandle();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }

            })
        }


    },

    mounted() {

    },
    computed: {

    },

    watch: {

    },
}
</script>
<style lang="less">
.notifyDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }

    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}
</style>

